import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const DELIVERABLES_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('DELIVERABLES');
export const DELIVERABLES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	DELIVERABLES_CRUD_ACTION_CONSTANTS
);
